/**
 * AcessoHeader Component - Page header and tabs
 */
import React from 'react';
import { Shield, Grid3x3, Users } from 'lucide-react';

type TabType = 'matriz' | 'usuarios';

interface AcessoHeaderProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export const AcessoHeader: React.FC<AcessoHeaderProps> = ({
  activeTab,
  onTabChange
}) => {
  return (
    <>
      {/* Page Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <Shield className="w-8 h-8 text-blue-600" />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Gestão de Permissões
          </h1>
        </div>
        <p className="text-gray-600 dark:text-gray-400">
          Configure as permissões de acesso para cada perfil do sistema
        </p>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 mb-6 border-b border-gray-200 dark:border-gray-700">
        <button
          onClick={() => onTabChange('matriz')}
          className={`flex items-center gap-2 px-6 py-3 font-medium transition-colors ${
            activeTab === 'matriz'
              ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
          }`}
        >
          <Grid3x3 className="w-5 h-5" />
          Matriz de Permissões
        </button>
        <button
          onClick={() => onTabChange('usuarios')}
          className={`flex items-center gap-2 px-6 py-3 font-medium transition-colors ${
            activeTab === 'usuarios'
              ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
          }`}
        >
          <Users className="w-5 h-5" />
          Permissões por Usuário
        </button>
      </div>
    </>
  );
};
